webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = exports.app = undefined;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(40);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueFire = __webpack_require__(110);
	var Firebase = __webpack_require__(19);
	
	_vue2.default.use(VueFire);
	
	var config = {
	  apiKey: "AIzaSyCGcGUwVRBPh_X-pWG6z0BwYZG7RikHs3Q",
	  authDomain: "running-year.firebaseapp.com",
	  databaseURL: "https://running-year.firebaseio.com",
	  storageBucket: "running-year.appspot.com",
	  messagingSenderId: "687831310103"
	};
	
	Firebase.initializeApp(config);
	
	var app = new _vue2.default({
	  el: '#app',
	  data: {
	    showNewPostModal: false
	  },
	  store: _store2.default,
	  components: {
	    'logo-header': __webpack_require__(102),
	    'pledge': __webpack_require__(104),
	    'resources': __webpack_require__(105)
	  },
	  created: function created() {}
	});
	
	exports.app = app;
	exports.store = _store2.default;

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var https = __webpack_require__(79);
	
	var firebase = __webpack_require__(19);
	var timestampRef = firebase.database().ref('timestamp');
	
	exports.default = {
	  name: 'logo-header',
	  data: function data() {
	    return {
	      sharedState: this.$store.state,
	      tabActive: true
	    };
	  },
	
	
	  filters: {
	    firstName: function firstName(fullName) {
	      var spaceLocation = fullName.indexOf(" ");
	
	      if (spaceLocation && spaceLocation > 1) {
	        return fullName.substring(0, spaceLocation);
	      }
	
	      return fullName;
	    }
	  },
	
	  computed: {},
	
	  methods: {},
	
	  mounted: function mounted() {
	
	    var parent = this;
	
	    window.onfocus = function () {
	      parent.tabActive = true;
	    };
	
	    window.onblur = function () {
	      parent.tabActive = false;
	    };
	
	    setInterval(function () {
	
	      if (parent.tabActive) {
	        timestampRef.transaction(function (lastTimestamp) {
	          var timestamp = Date.now() / 1000 | 0;
	
	          if (isFinite(timestamp) && timestamp > 0 && timestamp > lastTimestamp) {
	            return timestamp;
	          }
	        });
	      }
	    }, 30000);
	
	    var options = {
	      host: 'ip.nf',
	      path: '/me.json',
	      method: 'GET'
	    };
	
	
	    var req = https.request(options, function (res) {
	
	      if (res.statusCode == "200") {
	
	        res.setEncoding('utf8');
	
	        res.on('data', function (locationString) {
	
	          var location = JSON.parse(locationString);
	
	          if (location.ip.city) {
	            parent.sharedState.newUser.location.city = location.ip.city;
	          }
	
	          if (location.ip.country) {
	            parent.sharedState.newUser.location.country = location.ip.country;
	          }
	
	          if (location.ip.country_code) {
	            parent.sharedState.newUser.location.code = location.ip.country_code;
	          }
	        });
	      }
	    });
	
	    req.end();
	  }
	};

/***/ },

/***/ 36:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'modal',
	  data: function data() {
	    return {
	      sharedState: this.$store.state
	    };
	  },
	
	
	  filters: {},
	
	  computed: {},
	
	  methods: {
	
	    hideModal: function hideModal() {
	      this.sharedState.showModal = false;
	    }
	
	  },
	  mounted: function mounted() {
	
	    var p = this;
	
	    document.addEventListener("keydown", function (e) {
	      if (p.sharedState.showModal && e.keyCode == 27) {
	        p.sharedState.showModal = false;
	      }
	    });
	  }
	};

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(41);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vue = __webpack_require__(11);
	
	
	Vue.component('icon', {
	  props: ['type', 'dropdown'],
	
	  methods: {
	    showDropdown: function showDropdown(event) {
	      return this.dropdown === "true";
	    }
	  },
	  template: '<label><span :class="type"></span><span v-if="showDropdown()" class="dropdown-arrow icon-down-open"></span></label>'
	});
	
	Vue.component('read-more', {
	  props: ['newLine'],
	  data: function data() {
	    return {
	      slotVisible: false
	    };
	  },
	  methods: {
	    showText: function showText(event) {
	      this.slotVisible = true;
	      return false;
	    },
	    isNewLine: function isNewLine(evenet) {
	      return this.newLine;
	    }
	  },
	  template: '<span><span v-show="!this.slotVisible"><span v-if="!isNewLine()">... </span><a href="#read-more" class="read-more" v-on:click.prevent="showText"><span v-if="isNewLine()">Read more</span><span v-else>read more</span> &rsaquo;</a></span><span v-show="this.slotVisible"><slot>TEXT</slot></span></span>'
	});
	
	var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var Vuex = __webpack_require__(34);
	
	var Firebase = __webpack_require__(19);
	var usersRef = Firebase.database().ref('users');
	var entriesRef = Firebase.database().ref('totalentries');
	
	function encodeAsFirebaseKey(string) {
	  return string.replace(/\%/g, '%25').replace(/\./g, '%2E').replace(/\#/g, '%23').replace(/\$/g, '%24').replace(/\//g, '%2F').replace(/\[/g, '%5B').replace(/\]/g, '%5D');
	};
	
	exports.default = {
	  name: 'pledge',
	  data: function data() {
	    return {
	      sharedState: this.$store.state,
	      pledgeVia: 'facebook.com',
	      showErrors: false,
	      formattedTotalPeople: 0,
	      rawTotalPeople: 0,
	      rawUpdatedTotal: 0,
	      interval: false,
	
	      counter: 0,
	      wait: 2000,
	      total: 0
	    };
	  },
	
	
	  filters: {
	    firstName: function firstName(fullName) {
	      var spaceLocation = fullName.indexOf(" ");
	
	      if (spaceLocation && spaceLocation > 1) {
	        return fullName.substring(0, spaceLocation);
	      }
	
	      return fullName;
	    }
	  },
	
	  firebase: {
	    users: usersRef
	  },
	
	  computed: {
	    newUser: function newUser() {
	      return this.sharedState.newUser;
	    },
	    isPledgeCompleted: function isPledgeCompleted() {
	      return this.sharedState.pledgeCompleted;
	    },
	
	
	    validation: function validation() {
	      return {
	        name: !!this.newUser.name.trim(),
	        email: emailRE.test(this.newUser.email)
	      };
	    },
	    isValid: function isValid() {
	      var validation = this.validation;
	      return (0, _keys2.default)(validation).every(function (key) {
	        return validation[key];
	      });
	    }
	  },
	
	  methods: {
	
	    resizeCounter: function resizeCounter() {
	
	      var counterClass = '';
	      var numberLength = this.rawTotalPeople.toString().length;
	
	
	      if (numberLength > 4) {
	        counterClass = 'small';
	      }
	
	      if (numberLength > 5) {
	        counterClass = 'smaller';
	      }
	
	      if (numberLength > 6) {
	        counterClass = 'smallest';
	      }
	
	      return counterClass;
	    },
	
	    getSharingUrl: function getSharingUrl() {
	      var anchor = this.sharedState.newUser.id ? "#" + this.sharedState.newUser.id : "";
	      return 'https://www.runningyear.com/' + anchor;
	    },
	
	    share: function share(provider) {
	      var url = '';
	      var anchor = this.sharedState.newUser.id ? "%23" + this.sharedState.newUser.id : "";
	      var website = 'http%3A//www.runningyear.com/' + anchor;
	
	      switch (provider) {
	        case 'facebook':
	          url = "https://www.facebook.com/sharer/sharer.php?u=" + website;
	          break;
	
	        case 'twitter':
	          url = "https://twitter.com/home?status=I%20pledge%20to%20run%20at%20least%2030%20minutes%20a%20month%20in%20" + this.sharedState.year + ".%20Will%20you%20join%20me%3F%20%23RunningYear%20" + website;
	          break;
	
	        case 'linkedin':
	          url = "https://www.linkedin.com/shareArticle?mini=true&url=" + website + "&title=Running%20Year-%20Pledge%20to%20run%20at%20least%2030%20minutes%20a%20month&summary=Join%20a%20community%20of%20people%20who%20have%20pledged%20to%20run%20at%20least%2030%20minutes%20a%20month%20in%20" + this.sharedState.year + ",%20gain%20access%20to%20hundreds%20of%20resources%20and%20help%20get%20more%20people%20fit!&source=";
	          break;
	
	        case 'mail':
	        case 'email':
	          url = "mailto:?subject=Pledge%20to%20run%20in%20" + this.sharedState.year + "&body=Join+me+in+pledging+to+run+in+" + this.sharedState.year + "+https:%2F%2Fwww.runningyear.com%2F" + anchor;
	          break;
	      }
	
	      return window.open(url, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=650,height=330');
	    },
	
	    saveUserData: function saveUserData(user) {
	
	      if (user) {
	
	        if (user.displayName) {
	          this.sharedState.newUser.name = user.displayName;
	        }
	
	        if (user.email) {
	          this.sharedState.newUser.email = user.email;
	        }
	
	        if (user.photoURL) {
	          this.sharedState.newUser.pic = user.photoURL;
	        }
	
	        if (user.uid) {
	          this.sharedState.newUser.id = user.uid;
	          location.href = "#" + user.uid;
	        }
	      }
	    },
	
	    pledgeComplete: function pledgeComplete() {
	      this.sharedState.pledgeCompleted = true;
	    },
	
	    recordPledge: function recordPledge(user) {
	
	      var dbuser = {
	        email: user.email ? user.email : user.providerData[0].email ? user.providerData[0].email : null,
	        name: user.displayName ? user.displayName : user.providerData[0].displayName ? user.providerData[0].displayName : null,
	        photo: user.photoURL ? user.photoURL : user.providerData[0].photoURL ? user.providerData[0].photoURL : null,
	        network: user.providerData[0].providerId ? user.providerData[0].providerId : null,
	        location: {
	          city: this.sharedState.newUser.location.city,
	          country: this.sharedState.newUser.location.country,
	          country_code: this.sharedState.newUser.location.code
	        }
	      };
	
	      var uid = user.uid;
	
	      usersRef.child(uid).once('value', function (snapshot) {
	        var pledgeExists = snapshot.val() !== null;
	
	        if (pledgeExists) {} else {
	          usersRef.child(uid).set(dbuser);
	
	          entriesRef.transaction(function (currentVal) {
	            isFinite(currentVal) || (currentVal = 0);
	            return currentVal + 1;
	          });
	        }
	      });
	
	      this.pledgeComplete();
	    },
	
	    pledge: function pledge(providerName) {
	      var parent = this;
	      var provider = null;
	
	      if (providerName == 'facebook.com') {
	        provider = new Firebase.auth.FacebookAuthProvider();
	
	        provider.setCustomParameters({
	          'display': 'popup'
	        });
	      } else if (providerName == 'twitter.com') {
	        provider = new Firebase.auth.TwitterAuthProvider();
	      } else if (providerName == 'google.com') {
	        provider = new Firebase.auth.GoogleAuthProvider();
	      }
	
	      if (provider) {
	
	        Firebase.auth().signInWithPopup(provider).then(function (result) {
	          var user = result.user;
	
	          parent.saveUserData(user);
	
	          parent.recordPledge(user);
	        }).catch(function (error) {
	
	          var user = Firebase.auth().currentUser;
	
	          if (user) {
	            parent.saveUserData(user);
	          }
	
	          parent.handlePledgeError(error);
	        });
	      } else {
	
	        if (!this.isValid) {
	          this.showErrors = true;
	          return;
	        }
	
	        var fullName = this.newUser.name;
	        var email = this.newUser.email;
	
	        var password = "";
	
	        Firebase.auth().createUserWithEmailAndPassword(email, email).then(function (user) {
	
	          if (fullName) {
	
	            user.updateProfile({
	              displayName: fullName
	            }).then(function () {
	              parent.saveUserData(user);
	
	              parent.recordPledge(user);
	            });
	          } else {
	            parent.saveUserData(user);
	
	            parent.recordPledge(user);
	          }
	        }).catch(function (error) {
	
	          var user = Firebase.auth().currentUser;
	
	          parent.saveUserData(user);
	          parent.handlePledgeError(error);
	        });
	      }
	    },
	
	    handlePledgeError: function handlePledgeError(error) {
	      var errorCode = error.code;
	
	
	      switch (errorCode) {
	        case 'auth/account-exists-with-different-credential':
	        case 'auth/email-already-in-use':
	        case 'auth/credential-already-in-use':
	          this.pledgeComplete();
	
	          break;
	
	        case 'auth/invalid-email':
	          alert("Invalid email");
	          break;
	
	        default:
	          break;
	      }
	    },
	
	    getTotalPeople: function getTotalPeople() {
	      var p = this;
	
	      entriesRef.on("value", function (snap) {
	
	        p.rawUpdatedTotal = snap.val();
	
	        if (!p.rawTotalPeople) {
	
	          p.interval = window.setInterval(function () {
	
	            if (p.rawTotalPeople != p.rawUpdatedTotal) {
	              var change = (p.rawUpdatedTotal - p.rawTotalPeople) / 10;
	              change = change >= 0 ? Math.ceil(change) : Math.floor(change);
	              p.rawTotalPeople = p.rawTotalPeople + change;
	
	              p.formattedTotalPeople = p.rawTotalPeople.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	            } else {
	              clearInterval(p.interval);
	            }
	          }.bind(p), 65);
	        } else {
	          var total = snap.val();
	          var formattedTotal = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	          p.formattedTotalPeople = formattedTotal;
	        }
	      });
	    }
	  },
	
	  mounted: function mounted() {
	
	    var parent = this;
	
	    this.getTotalPeople();
	
	    Firebase.auth().onAuthStateChanged(function (user) {
	      if (user) {
	        parent.saveUserData(user);
	        parent.pledgeComplete();
	      }
	    });
	
	    if (window.location.hash) {
	      var userId = window.location.hash.substring(1);
	      var userData = null;
	
	      usersRef.child(userId).once('value').then(function (snapshot) {
	        userData = snapshot.val();
	
	        if (userData) {
	          parent.sharedState.wasReferred = true;
	          parent.sharedState.referralUser = userData;
	
	          if (userData.network) {
	            parent.pledgeVia = userData.network;
	          }
	        }
	      });
	    } else {}
	  }
	};

/***/ },

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(39);
	
	var Vue = __webpack_require__(11);
	
	Vue.component('resource-collection', {
	  props: {
	    cardClass: {
	      type: String,
	      required: true
	    },
	
	    totalItems: {
	      type: Number,
	      required: false
	    },
	
	    isUnlocked: {
	      type: Boolean,
	      required: true
	    }
	  },
	
	  filters: {
	    doubleDigit: function doubleDigit(digit) {
	      return digit <= 9 ? '0' + digit : digit;
	    }
	  },
	
	  template: '<div><div class="resource resourceCollection"><div :class="cardClass" class="card"><slot name="title">DEFAULT-TITLE</slot><slot name="description">DEFAULT-DESC</slot><span>{{ totalItems | doubleDigit }}</span></div><div class="button"><label v-if="isUnlocked">View resources &rsaquo;</label><label v-else>Pledge to view</label></div></div><div class="total">{{ totalItems }} resources</div></div>'
	});
	
	Vue.component('resource', {
	  props: {
	    website: {
	      type: String,
	      required: false
	    },
	    logo: {
	      type: String,
	      required: false
	    }
	  },
	
	  filters: {
	    logoPath: function logoPath(filename) {
	      if (filename.indexOf("://") > -1) {
	        return filename;
	      }
	
	      return "./static/resources/" + filename;
	    },
	    clearURL: function clearURL(url) {
	
	      if (!url) return '';
	
	      var domain;
	
	      if (url.indexOf("://") > -1) {
	        domain = url.split('/')[2];
	      } else {
	        domain = url.split('/')[0];
	      }
	
	      if (domain.indexOf("www.") > -1) {
	        domain = domain.split('www.')[1];
	      }
	
	      domain = domain.charAt(0).toUpperCase() + domain.slice(1);
	
	      if (domain == "Amzn.to") {
	        return "Amazon.com";
	      }
	
	      if (domain.length >= 20) {
	        return domain.substring(0, 20) + '...';
	      }
	
	      return domain;
	    }
	  },
	
	  template: '<div class="resource"><div class="card"><slot name="title">DEFAULT-TITLE</slot><slot name="description">DEFAULT-DESC</slot><img :src="logo | logoPath" class="resourceLogo" /></div><div class="button">Go to {{ website | clearURL}} &rsaquo;</div></div>'
	});
	
	exports.default = {
	  name: 'resources',
	  data: function data() {
	    return {
	      sharedState: this.$store.state,
	      currentResource: false,
	      resources: resourceCollection,
	      showModal: false
	    };
	  },
	
	  components: {
	    'modal': __webpack_require__(103)
	  },
	
	  computed: {
	    isPledgeCompleted: function isPledgeCompleted() {
	      return this.sharedState.pledgeCompleted;
	    }
	  },
	
	  methods: {
	
	    noResourceSelected: function noResourceSelected() {
	      return this.currentResource === false;
	    },
	
	    setCurrentResource: function setCurrentResource(resourceName) {
	
	      if (this.isPledgeCompleted) {
	        this.currentResource = resourceName;
	      } else {
	
	        this.sharedState.showModal = true;
	
	        var btn = document.getElementById('pledgeButtons');
	        btn.classList ? btn.classList.add('pulsate') : btn.className += ' pulsate';
	        window.location.hash = '#pledge-form';
	        history.pushState("", document.title, window.location.pathname);
	      }
	    },
	
	    isCurrentResource: function isCurrentResource(resourceName) {
	      return this.currentResource === resourceName;
	    },
	
	    getResourceData: function getResourceData(field) {
	      var resource = this.currentResource;
	
	      if (field == "description") {
	        var desc = resourceCollection[resource][field];
	        var totalResources = resourceCollection[resource].resources.length;
	        return desc + " • " + totalResources + " resources";
	      }
	
	      return resourceCollection[resource][field];
	    },
	
	    getResourceCount: function getResourceCount() {
	      var totalResources = 0;
	
	      for (var resIndex in resourceCollection) {
	        totalResources += resourceCollection[resIndex].resources.length;
	      }
	
	      this.sharedState.totalResources = totalResources;
	
	      return totalResources;
	    }
	  }
	};

/***/ },

/***/ 39:
/***/ function(module, exports) {

	"use strict";
	
	var resourceCollection = {
	  "gettingstarted": {
	    "name": "Getting Started",
	    "description": "Resources for beginners",
	    "resources": [{
	      "name": "8-week beginner's guide",
	      "description": "Designed to get you to the point where you can run 30 minutes at a relaxed pace",
	      "website": "http://www.runnersworld.com/training/the-8-week-beginners-guide",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "How to start running",
	      "description": "Already in the habit of regular exercise? Want to add running to your routine?",
	      "website": "http://www.runnersworld.com/the-starting-line/start-running",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Ultimate guide to running",
	      "description": "The Beginners Corner section of Strength Running will show you how to start running",
	      "website": "http://strengthrunning.com/how-to-start-running/",
	      "logo": "strengthrunning.jpg"
	    }, {
	      "name": "Here's how to start running",
	      "description": "Here's How To Start Running, Stick With It, And Not Totally Hate It",
	      "website": "https://www.buzzfeed.com/sallytamarkin/heres-how-to-actually-start-running-if-youre-a-total-beginne",
	      "logo": "buzzfeed.png"
	    }, {
	      "name": "Beginner's guide to running",
	      "description": "Establish a solid foundation for your future development as a runner",
	      "website": "http://www.active.com/running/articles/beginner-s-guide-to-running",
	      "logo": "active.jpg"
	    }, {
	      "name": "5K training plan",
	      "description": "Couch to 5K: A running plan for beginners",
	      "website": "http://www.nhs.uk/Livewell/c25k/Pages/couch-to-5k.aspx",
	      "logo": "couchto5k.png"
	    }, {
	      "name": "How to start running",
	      "description": "Starting a new running habit doesn’t have to be hard (The New York Times)",
	      "website": "http://www.nytimes.com/well/guides/how-to-start-running",
	      "logo": "nytimes.jpg"
	    }]
	  },
	  "clothing": {
	    "name": "Running clothing",
	    "description": "Clothing for men & women",
	    "resources": [{
	      "name": "What to wear",
	      "description": "Expert advice about the right stuff to wear (Runner's World)",
	      "website": "http://www.runnersworld.com/what-to-wear",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Shoe search",
	      "description": "Find the right kind of shoe for you (Runner's World)",
	      "website": "http://www.runnersworld.com/shoesearch",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Selecting the best shoes",
	      "description": "Running 101: How To Select The Best Pair Of Running Shoes",
	      "website": "http://running.competitor.com/2014/09/shoes-and-gear/running-101-how-to-select-the-best-pair-of-running-shoes_49598",
	      "logo": "competitor.jpg"
	    }, {
	      "name": "Decathlon",
	      "description": "Sporting retailer operating in 38 countries",
	      "website": "https://www.decathlon.com",
	      "logo": "decathlon.png"
	    }, {
	      "name": "Men's long sleeve tops",
	      "description": "Find tops for every budget, from high-performance fabrics to basics",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20long%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's long sleeve tops",
	      "description": "Find tops for every budget, from high-performance fabrics to basics",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20long%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Men's short sleeve tops",
	      "description": "Find tops for every budget, from high-performance fabrics to basics",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20short%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's short sleeve tops",
	      "description": "Find tops for every budget, from high-performance fabrics to basics",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20short%20sleeve%20running%20top&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Men's long trousers/tights",
	      "description": "Perfect for winter or cold, rainy days",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20long%20running%20tights%20trousers&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's long tights",
	      "description": "Perfect for winter or cold, rainy days",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20long%20running%20tights%20trousers&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Men's running shorts",
	      "description": "Find the best fitting and looking shorts here",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20shorts&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's running shorts",
	      "description": "Find the best fitting and best looking shorts here",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20shorts&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Men's running shoes",
	      "description": "Find the best fitting running shoes and tackle any kind of terrain",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20shoes&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's running shoes",
	      "description": "Find the best fitting running shoes and tackle any kind of terrain",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20shoes&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Men's running socks",
	      "description": "Find the most comfortable running socks for all running shoes and terrains",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=men%20running%20socks&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's running socks",
	      "description": "Find the most comfortable running socks for all running shoes and terrains",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=women%20running%20socks&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }, {
	      "name": "Women's sports bras",
	      "description": "Discover the best sports bras out there and have more comfortable runs",
	      "website": "https://www.amazon.co.uk/gp/search?ie=UTF8&camp=1634&creative=6738&index=sports&keywords=sports%20bra&linkCode=ur2&tag=guill0e-21",
	      "logo": "amazon.jpg"
	    }]
	  },
	  "accessories": {
	    "name": "Fitness Trackers",
	    "description": "Wearable trackers and watches",
	    "resources": [{
	      "name": "Garmin Vivosmart HR+",
	      "description": "Tracks heart rate, displays steps, calories, distance, floors climbed, intensity...",
	      "website": "http://amzn.to/2ijANSE",
	      "logo": "garmin.png"
	    }, {
	      "name": "Fitbit Charge 2",
	      "description": "Track steps, distance, calories burned, floors climbed, active minutes and hourly activity",
	      "website": "http://amzn.to/2hxUBO9",
	      "logo": "fitbit.png"
	    }, {
	      "name": "Misfit Ray",
	      "description": "Misfit Ray is a minimal and versatile tracker.",
	      "website": "http://amzn.to/2i8OlgD",
	      "logo": "misfit.png"
	    }, {
	      "name": "Fitbit Alta",
	      "description": "Automatically track how long and how well you sleep and set a silent vibrating alarm",
	      "website": "http://amzn.to/2hfxvOx",
	      "logo": "fitbit.png"
	    }, {
	      "name": "Misfit Shine 2",
	      "description": "Track steps, calories, distance, light and deep sleep",
	      "website": "http://amzn.to/2hjbqjR",
	      "logo": "misfit.png"
	    }, {
	      "name": "Jawbone UP3",
	      "description": "The simplest way to get credit for your steps, exercise and overall calories",
	      "website": "http://amzn.to/2hfxRoq",
	      "logo": "jawbone.jpg"
	    }, {
	      "name": "Moov Now",
	      "description": "A wearable fitness coach that actively monitors your tendencies",
	      "website": "http://amzn.to/2iju5MA",
	      "logo": "moov.jpg"
	    }, {
	      "name": "Xiaomi Mi Band 2",
	      "description": "The latest wearable fitness tracker from Chinese hardware giant Xiaomi",
	      "website": "http://amzn.to/2hfya2y",
	      "logo": "xiaomi.png"
	    }, {
	      "name": "Xiaomi Mi Band 1S",
	      "description": "Budget step & sleep tracker with heart rate monitoring",
	      "website": "http://amzn.to/2hfA0kc",
	      "logo": "xiaomi.png"
	    }, {
	      "name": "TomTom Touch",
	      "description": "TomTom Touch tracks steps, sleep and heart rate and body composition",
	      "website": "http://amzn.to/2ijpMAX",
	      "logo": "tomtom.png"
	    }, {
	      "name": "Garmin Vivoactive HR",
	      "description": "GPS smart watch with a sunlight-readable, high-resolution colour touchscreen",
	      "website": "http://amzn.to/2hxPqOo",
	      "logo": "garmin.png"
	    }, {
	      "name": "Samsung Gear Fit2",
	      "description": "A GPS fitness band you can run with while your phone stays at home.",
	      "website": "http://amzn.to/2hfCqPE",
	      "logo": "samsung.png"
	    }, {
	      "name": "Skagen Hagen",
	      "description": "Hybrid smartwatch that marries the best of modern innovation with classic watchmaking",
	      "website": "http://amzn.to/2hfrK3F",
	      "logo": "skagen.jpg"
	    }, {
	      "name": "Microsoft Band 2",
	      "description": "Unique lifestyle tool that helps keep you on track and productive",
	      "website": "http://amzn.to/2i8UVno",
	      "logo": "microsoft.jpg"
	    }, {
	      "name": "Under Armour UA Band",
	      "description": "UA Band measures sleep, resting heart rate, steps & more",
	      "website": "http://amzn.to/2hy21RJ",
	      "logo": "underarmour.jpg"
	    }, {
	      "name": "Withings Go",
	      "description": "Withings Go Activity, Swim and Sleep Tracker",
	      "website": "http://amzn.to/2hfCgHX",
	      "logo": "withings.png"
	    }]
	  },
	  "races": {
	    "name": "Races",
	    "description": "5K, 10K, Half Marathons and Marathons",
	    "resources": [{
	      "name": "MyNextRun",
	      "description": "Online running calendar with nearly 15000 events",
	      "website": "https://www.mynextrun.com/",
	      "logo": "mynextrun.png"
	    }, {
	      "name": "Ahotu Marathons",
	      "description": "International running calendar and runners' resources",
	      "website": "http://marathons.ahotu.com/",
	      "logo": "ahotumarathons.png"
	    }, {
	      "name": "Runner's World",
	      "description": "Race finder for USA",
	      "website": "http://www.runnersworld.com/race-finder",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "HalfMarathons.net",
	      "description": "Half marathon finder",
	      "website": "http://www.halfmarathons.net/",
	      "logo": "halfmarathonsnet.jpeg"
	    }, {
	      "name": "New York City Marathon",
	      "description": "11 May 2017",
	      "website": "http://www.tcsnycmarathon.org/",
	      "logo": "tcsnyc.png"
	    }, {
	      "name": "Chicago Marathon",
	      "description": "8 October 2017",
	      "website": "https://www.chicagomarathon.com/",
	      "logo": "chicagomarathon.png"
	    }, {
	      "name": "Marathon de Paris",
	      "description": "9 April 2017",
	      "website": "http://www.schneiderelectricparismarathon.com/",
	      "logo": "marathonparis.jpg"
	    }, {
	      "name": "London Marathon",
	      "description": "23 April 2017",
	      "website": "https://www.virginmoneylondonmarathon.com/",
	      "logo": "londonmarathon.jpg"
	    }, {
	      "name": "Tokyo Marathon",
	      "description": "26 February 2017",
	      "website": "http://www.marathon.tokyo/en/",
	      "logo": "tokyomarathon.png"
	    }, {
	      "name": "Boston Marathon",
	      "description": "17 April 2017",
	      "website": "http://www.baa.org/races/boston-marathon.aspx",
	      "logo": "bostonmarathon.jpg"
	    }, {
	      "name": "Berlin Marathon",
	      "description": "24 September 2017",
	      "website": "http://www.bmw-berlin-marathon.com/",
	      "logo": "berlinmarathon.png"
	    }, {
	      "name": "Osaka Marathon",
	      "description": "26 November 2017",
	      "website": "http://www.osaka-marathon.com/index_en.html",
	      "logo": "osakamarathon.jpg"
	    }, {
	      "name": "Honolulu Marathon",
	      "description": "10 December 2017",
	      "website": "http://www.honolulumarathon.org/",
	      "logo": "honolulumarathon.jpg"
	    }, {
	      "name": "LA Marathon",
	      "description": "19 March 2017",
	      "website": "http://www.lamarathon.com/",
	      "logo": "lamarathon.jpg"
	    }]
	  },
	  "apps": {
	    "name": "Useful Apps",
	    "description": "Apps for planning and tracking runs",
	    "resources": [{
	      "name": "Strava",
	      "description": "Run and cycling tracking on the social network for athletes",
	      "website": "https://www.strava.com/",
	      "logo": "strava.jpg"
	    }, {
	      "name": "MapMyRun",
	      "description": "Running, running maps, running routes and running community",
	      "website": "http://www.mapmyrun.com/",
	      "logo": "mapmyrun.jpg"
	    }, {
	      "name": "RunKeeper",
	      "description": "Track your runs, walks and more",
	      "website": "https://runkeeper.com/index",
	      "logo": "runkeeper.jpg"
	    }, {
	      "name": "Nike+ Run Club",
	      "description": "Your perfect running partner",
	      "website": "https://www.nike.com/us/en_us/p/activity",
	      "logo": "nikeplus.jpg"
	    }, {
	      "name": "Couch to 5K",
	      "description": "Easy, fun 5K training plan for beginner runners",
	      "website": "http://www.active.com/mobile/couch-to-5k-app",
	      "logo": "couchto5k.png"
	    }, {
	      "name": "Endomondo",
	      "description": "Free your endorphins running, walking, cycling and more",
	      "website": "https://www.endomondo.com/",
	      "logo": "endomondo.jpg"
	    }, {
	      "name": "Runtastic",
	      "description": "Running, cycling & fitness GPS tracker",
	      "website": "https://www.runtastic.com/",
	      "logo": "runtastic.png"
	    }, {
	      "name": "iSmoothRun",
	      "description": "GPS/pedometer tracker for runners",
	      "website": "http://www.ismoothrun.com/",
	      "logo": "ismoothrun.png"
	    }, {
	      "name": "Wahoo fitness",
	      "description": "Connected cycling, running and fitness",
	      "website": "http://www.wahoofitness.com/",
	      "logo": "wahoofitness.jpg"
	    }, {
	      "name": "Runmeter",
	      "description": "iPhone app for running, cycling, walking and more",
	      "website": "http://abvio.com/runmeter/",
	      "logo": "runmeter.png"
	    }]
	  },
	  "parkrun": {
	    "name": "Parkrun",
	    "description": "Weekly 5K runs all over the world",
	    "resources": [{
	      "name": "parkrun Australia",
	      "description": "Free weekly 5km timed runs in Australia",
	      "website": "http://www.parkrun.com.au/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Canada",
	      "description": "Free weekly 5km timed runs in Canada",
	      "website": "http://www.parkrun.ca/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Denmark",
	      "description": "Free weekly 5km timed runs in Denmark",
	      "website": "http://www.parkrun.dk/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun France",
	      "description": "Free weekly 5km timed runs in France",
	      "website": "http://www.parkrun.fr/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Ireland",
	      "description": "Free weekly 5km timed runs in Ireland",
	      "website": "http://www.parkrun.ie/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Italy",
	      "description": "Free weekly 5km timed runs in Italy",
	      "website": "http://www.parkrun.it/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun New Zealand",
	      "description": "Free weekly 5km timed runs in New Zealand",
	      "website": "http://www.parkrun.co.nz/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Poland",
	      "description": "Free weekly 5km timed runs in Poland",
	      "website": "http://www.parkrun.pl/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Russia",
	      "description": "Free weekly 5km timed runs in Russia",
	      "website": "http://www.parkrun.ru/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Singapore",
	      "description": "Free weekly 5km timed runs in Singapore",
	      "website": "http://www.parkrun.sg/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun South Africa",
	      "description": "Free weekly 5km timed runs in South Africa",
	      "website": "http://www.parkrun.co.za/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun Sweden",
	      "description": "Free weekly 5km timed runs in Sweden",
	      "website": "http://www.parkrun.se/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun UK",
	      "description": "Free weekly 5km timed runs in UK",
	      "website": "http://www.parkrun.org.uk/",
	      "logo": "parkrun.jpg"
	    }, {
	      "name": "parkrun USA",
	      "description": "Free weekly 5km timed runs in USA",
	      "website": "http://www.parkrun.us/",
	      "logo": "parkrun.jpg"
	    }]
	  },
	  "injuries": {
	    "name": "Injury Prevention",
	    "description": "Resources about injury prevention",
	    "resources": [{
	      "name": "Articles on injury prevention",
	      "description": "Learn the best ways to stay injury free (Competitor)",
	      "website": "http://running.competitor.com/category/injury-prevention",
	      "logo": "competitor.jpg"
	    }, {
	      "name": "Preventing running injuries",
	      "description": "Learn best running practices, commmon injuries and how to prevent them",
	      "website": "http://www.stopsportsinjuries.org/STOP/Prevent_Injuries/Running_Injury_Prevention.aspx",
	      "logo": "stopsportsinjuries.jpg"
	    }, {
	      "name": "Injury prevention & recovery",
	      "description": "The best articles on injury prevention & recovery by Runner's World",
	      "website": "http://www.runnersworld.com/tag/injury-prevention-recovery",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Injury prevention articles",
	      "description": "Use this guide to avoid common aches and pains and perform your best",
	      "website": "http://www.active.com/fitness/injury-prevention",
	      "logo": "active.jpg"
	    }, {
	      "name": "Training articles archive",
	      "description": "Learn about common running injuries and how to best avoid them",
	      "website": "https://runnersconnect.net/category/running-injury-prevention/",
	      "logo": "runnersconnect.png"
	    }]
	  },
	  "websites": {
	    "name": "Running Websites",
	    "description": "General running and fitness websites",
	    "resources": [{
	      "name": "Runner's World",
	      "description": "Shoe reviews, training advice, running news, nutrition tips",
	      "website": "http://www.runnersworld.com/",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Active",
	      "description": "Find & Register for Races, Local Events & Things to Do",
	      "website": "http://www.active.com/",
	      "logo": "active.jpg"
	    }, {
	      "name": "Competitor",
	      "description": "Marathon Training Plans, Running Shoe Reviews, Nutrition",
	      "website": "http://running.competitor.com/",
	      "logo": "competitor.jpg"
	    }, {
	      "name": "Men's Fitness",
	      "description": "A source for exercise, health and nutrition advice",
	      "website": "http://www.mensfitness.com/topics/running",
	      "logo": "mensfitness.jpg"
	    }, {
	      "name": "Women's Running",
	      "description": "Women's running training advice, kit reviews, running shoe reviews and more",
	      "website": "http://womensrunning.competitor.com/",
	      "logo": "womensrunning.jpg"
	    }, {
	      "name": "Fitness",
	      "description": "Fitness, beauty, wellness, food and other topics",
	      "website": "http://www.fitnessmagazine.com/run/",
	      "logo": "fitness.jpg"
	    }, {
	      "name": "RunnersConnect",
	      "description": "Training plans, training schedules and running programs",
	      "website": "https://runnersconnect.net/",
	      "logo": "runnersconnect.png"
	    }]
	  },
	  "nutrition": {
	    "name": "Nutrition",
	    "description": "Information about nutrition and diet",
	    "resources": [{
	      "name": "Articles and recipes",
	      "description": "Information regarding running nutrition and healthy eating by Competitor.com",
	      "website": "http://running.competitor.com/category/nutrition",
	      "logo": "competitor.jpg"
	    }, {
	      "name": "Nutrition & weight loss",
	      "description": "The best Runner's world articles & recipes to lose weight",
	      "website": "http://www.runnersworld.com/nutrition-weight-loss",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Meal plans for runners",
	      "description": "Getting your training diet spot on will help you go that extra mile",
	      "website": "http://www.bbcgoodfood.com/howto/guide/running-nutrition-typical-training-plan",
	      "logo": "bbcgoodfood.jpg"
	    }, {
	      "name": "Nutrition guide",
	      "description": "Fuel your body with the right nutrients to stay in top shape, and perform your best",
	      "website": "http://www.active.com/nutrition",
	      "logo": "active.jpg"
	    }, {
	      "name": "Nutrition for runners",
	      "description": "Learn How to Eat for Optimal Performance and Lose Weight",
	      "website": "https://runnersconnect.net/nutrition-for-runners/",
	      "logo": "runnersconnect.png"
	    }, {
	      "name": "The best food for runners",
	      "description": "The 15 foods runners need every week for good health and top performance",
	      "website": "http://www.runnersworld.com/nutrition/the-best-foods-for-runners",
	      "logo": "runnersworld.jpeg"
	    }, {
	      "name": "Essential foods for runners",
	      "description": "Are you eating the foods you should be for energy, recovery, and fitness?",
	      "website": "http://running.competitor.com/2014/06/photos/photos-10-essential-foods-for-runners_11329",
	      "logo": "competitor.jpg"
	    }, {
	      "name": "Food for before/after a run",
	      "description": "Find out how to fuel up before and after your training runs to maximize results",
	      "website": "http://www.mensfitness.com/nutrition/what-to-eat/pre-and-post-workout-nutrition-for-runners",
	      "logo": "mensfitness.jpg"
	    }, {
	      "name": "The best food for runners",
	      "description": "Experts to tell us what should be considered the staples of a runner's diet",
	      "website": "http://www.huffingtonpost.com/2013/08/16/best-foods-for-runners_n_3762290.html",
	      "logo": "huffingtonpost.jpg"
	    }, {
	      "name": "Why runners shouldn't diet",
	      "description": "Find out why you shouldn't diet (and what to do instead)",
	      "website": "http://dailyburn.com/life/health/running-for-weight-loss-diet/",
	      "logo": "dailyburn.jpg"
	    }, {
	      "name": "Diet plan for runners",
	      "description": "Lose pounds by running. Here's the plan for week 1 (Women's Health)",
	      "website": "http://www.womenshealthmag.com/fitness/diet-plan-for-runners-week-1",
	      "logo": "womenshealth.jpg"
	    }]
	  }
	};
	
	
	window.resourceCollection = resourceCollection;

/***/ },

/***/ 40:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(34);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    strict: ("production") !== 'production',
	
	    pledgeCompleted: false,
	    totalResources: 0,
	
	    newUser: {
	      id: '',
	      name: '',
	      email: '',
	      pic: '',
	      location: {
	        city: '',
	        country: '',
	        code: ''
	      }
	    },
	
	    wasReferred: false,
	    referralUser: {
	      name: '',
	      pic: ''
	    },
	
	    showModal: false,
	
	    year: new Date().getUTCFullYear()
	  },
	
	  actions: {},
	
	  mutations: {},
	
	  getters: {}
	});
	
	exports.default = store;

/***/ },

/***/ 71:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 72:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 73:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 74:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 102:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(71)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 103:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(72)
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 104:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(74)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 105:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(73)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 106:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('header', {
	    staticClass: "content"
	  }, [_vm._m(0), _vm._v(" "), _c('h1', {
	    attrs: {
	      "id": "subject"
	    }
	  }, [(this.sharedState.pledgeCompleted) ? _c('span', {
	    staticClass: "bg"
	  }, [_vm._v("\n      Looking forward to seeing you run"), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.sharedState.newUser.name),
	      expression: "this.sharedState.newUser.name"
	    }]
	  }, [_vm._v(", " + _vm._s(_vm._f("firstName")(this.sharedState.newUser.name)))]), _vm._v("!\n    ")]) : _c('span', {
	    staticClass: "bg"
	  }, [_vm._v("\n      Pledge to run at least 30 minutes a month\n    ")]), _vm._v(" ")]), _vm._v(" ")])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "pure-g logo-wrap"
	  }, [_c('div', {
	    staticClass: "pure-u-6-24 logo-side"
	  }, [_c('div', {
	    staticClass: "logoline"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pure-u-12-24",
	    attrs: {
	      "id": "logo"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pure-u-6-24 logo-side"
	  }, [_c('div', {
	    staticClass: "logoline"
	  })])])
	}]}

/***/ },

/***/ 107:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "modal"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask",
	    on: {
	      "click": this.hideModal
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._t("header")], true), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("body", [_c('div', {
	    attrs: {
	      "id": "alert-dialog"
	    }
	  }, [_c('div', {
	    staticClass: "alert-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "alert-message"
	  }, [_c('h1', [_vm._v("Ooops!")]), _vm._v(" "), _c('p', [_vm._v("You need to \"Pledge to run\" to access the resources and get running reminders.")])])])])], true), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer", [_c('div', {
	    staticClass: "close-button",
	    on: {
	      "click": this.hideModal
	    }
	  }, [_vm._v("\n                Close\n              ")])])], true)])])])])])
	},staticRenderFns: []}

/***/ },

/***/ 108:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    class: this.currentResource,
	    attrs: {
	      "id": "lower-body"
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "resources"
	    }
	  }, [_c('div', {
	    staticClass: "pure-g"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "pure-u-1 pure-u-lg-1-2"
	  }, [_c('section', {
	    staticClass: "feature"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "sectionText"
	  }, [_c('h1', [_vm._v("Support Running Year")]), _vm._v(" "), _c('p', [_vm._v("Donate any amount to help us get more people fit, healthy and running in " + _vm._s(this.sharedState.year))]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _vm._v(" "), _c('section', {
	    staticClass: "feature"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "sectionText"
	  }, [_c('h1', [_vm._v("Running resources"), (this.currentResource) ? _c('span', [_vm._v(" › " + _vm._s(this.getResourceData('name')))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("We've curated a list of " + _vm._s(this.getResourceCount()) + " resources for runners, to get you on the right track and help you run better."), _c('br'), (this.sharedState.pledgeCompleted) ? _c('span', [_vm._v("Click on one of the categories below to get started..")]) : _c('span', [_vm._v("To access them, you need to pledge to run first.")])])])]), _vm._v(" "), _c('transition-group', {
	    attrs: {
	      "tag": "ul",
	      "name": "slide",
	      "id": "resourceMosaic"
	    }
	  }, [(this.currentResource) ? _c('li', {
	    key: "back",
	    on: {
	      "click": function($event) {
	        _vm.setCurrentResource(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "resource"
	  }, [_c('div', {
	    staticClass: "card goBackCard"
	  }, [_c('h2', [_vm._v("View the whole collection of running resources")])]), _vm._v(" "), _c('div', {
	    staticClass: "button"
	  }, [_vm._v("‹ Go Back")])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._l((_vm.resources), function(category, key) {
	    return [(_vm.noResourceSelected()) ? _c('li', {
	      key: category.name,
	      on: {
	        "click": function($event) {
	          _vm.setCurrentResource(key)
	        }
	      }
	    }, [_c('resource-collection', {
	      attrs: {
	        "cardClass": key,
	        "totalItems": category.resources.length,
	        "isUnlocked": _vm.isPledgeCompleted
	      }
	    }, [_c('h1', {
	      slot: "title"
	    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('p', {
	      slot: "description"
	    }, [_vm._v(_vm._s(category.description))])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._l((category.resources), function(resource) {
	      return (_vm.isCurrentResource(key)) ? _c('li', {
	        key: resource.name
	      }, [_c('a', {
	        staticClass: "resourceLink",
	        attrs: {
	          "href": resource.website,
	          "title": resource.name,
	          "target": "new"
	        }
	      }, [_c('resource', {
	        attrs: {
	          "website": resource.website,
	          "logo": resource.logo
	        }
	      }, [_c('h1', {
	        slot: "title"
	      }, [_vm._v(_vm._s(resource.name))]), _vm._v(" "), _c('p', {
	        slot: "description"
	      }, [_vm._v(_vm._s(resource.description))])])])]) : _vm._e()
	    }), _vm._v(" ")]
	  }), _vm._v(" ")], true)]), _vm._v(" "), (this.sharedState.showModal) ? _c('modal', {
	    on: {
	      "close": function($event) {
	        _vm.showModal = false
	      }
	    }
	  }) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "pure-u-1 pure-u-lg-1-2"
	  }, [_c('section', {
	    staticClass: "feature"
	  }, [_c('div', {
	    staticClass: "sectionIcon"
	  }, [_c('div', {
	    staticClass: "icon-bg"
	  }, [_c('label', {
	    staticClass: "icon-reminder"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "sectionText"
	  }, [_c('h1', [_vm._v("Running reminders")]), _vm._v(" "), _c('p', [_vm._v("By pledging to run you’ll receive occasional emails encouraging you to go out for a jog.\n")]), _c('div', {
	    staticClass: "small"
	  }, [_vm._v("This is a free service and you can unsubscribe at any time with a single click.")]), _c('p')])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "sectionIcon"
	  }, [_c('div', {
	    staticClass: "icon-bg"
	  }, [_c('label', {
	    staticClass: "icon-donate"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('form', {
	    attrs: {
	      "action": "https://www.paypal.com/cgi-bin/webscr",
	      "method": "post",
	      "target": "_top"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cmd",
	      "value": "_s-xclick"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "hosted_button_id",
	      "value": "MMFWNSKDZVWUA"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "border": "0",
	      "name": "submit",
	      "value": "Donate with PayPal",
	      "id": "donateButton"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "alt": "",
	      "border": "0",
	      "src": "https://www.paypalobjects.com/en_GB/i/scr/pixel.gif",
	      "width": "1",
	      "height": "1"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "sectionIcon"
	  }, [_c('div', {
	    staticClass: "icon-bg"
	  }, [_c('label', {
	    staticClass: "icon-resources"
	  })])])
	}]}

/***/ },

/***/ 109:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "pledge-wrap"
	    }
	  }, [_c('div', {
	    staticClass: "pure-g"
	  }, [_c('div', {
	    staticClass: "pure-u-1 pure-u-lg-13-24",
	    attrs: {
	      "id": "pledge-text"
	    }
	  }, [_c('table', {
	    attrs: {
	      "id": "runners-info"
	    }
	  }, [_c('tr', [_c('td', [(this.sharedState.wasReferred) ? _c('p', [_c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.sharedState.wasReferred && this.sharedState.referralUser.photo),
	      expression: "this.sharedState.wasReferred && this.sharedState.referralUser.photo"
	    }],
	    attrs: {
	      "src": this.sharedState.referralUser.photo,
	      "id": "referralImage"
	    }
	  }), _vm._v(" " + _vm._s(_vm._f("firstName")(this.sharedState.referralUser.name)) + " and\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
	    class: _vm.resizeCounter(),
	    attrs: {
	      "id": "total-runners"
	    }
	  }, [_vm._v(_vm._s(_vm.formattedTotalPeople))]), _vm._v(" "), _c('p', [_vm._v("people will be running in " + _vm._s(this.sharedState.year))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "pledge-footer noSelect"
	  }, [_c('ul', {
	    attrs: {
	      "id": "footer-social"
	    }
	  }, [_c('li', {
	    staticClass: "twitter",
	    on: {
	      "click": function($event) {
	        _vm.share('twitter')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-twitter"
	  }), _vm._v(" Tweet")]), _vm._v(" "), _c('li', {
	    staticClass: "facebook",
	    on: {
	      "click": function($event) {
	        _vm.share('facebook')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-facebook-official"
	  }), _vm._v(" Share")]), _vm._v(" "), _c('li', {
	    staticClass: "linkedin",
	    on: {
	      "click": function($event) {
	        _vm.share('linkedin')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-linkedin-squared"
	  }), _vm._v(" Share")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "pure-u-1 pure-u-lg-11-24",
	    attrs: {
	      "id": "pledge-form"
	    }
	  }, [_c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!this.isPledgeCompleted),
	      expression: "!this.isPledgeCompleted"
	    }]
	  }, [_vm._m(0), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "form",
	      "name": "emailForm"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.pledge('password')
	      }
	    }
	  }, [(this.pledgeVia === 'password') ? _c('div', {
	    staticClass: "pure-g",
	    attrs: {
	      "id": "manualForm"
	    }
	  }, [_c('div', {
	    staticClass: "pure-u-2-5 inputWrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.name),
	      expression: "newUser.name"
	    }],
	    staticClass: "inputField name",
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "placeholder": "Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "pure-u-3-5 inputWrap"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.email),
	      expression: "newUser.email"
	    }],
	    staticClass: "inputField email",
	    attrs: {
	      "type": "text",
	      "name": "email",
	      "placeholder": "Email address"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.email = $event.target.value
	      }
	    }
	  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "noSelect",
	    attrs: {
	      "id": "pledgeButtons"
	    }
	  }, [(this.pledgeVia === 'facebook.com') ? _c('div', [_c('div', {
	    staticClass: "button facebook"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.pledge('facebook.com')
	      }
	    }
	  }, [_vm._v("Pledge to run via Facebook")]), _vm._v(" "), _c('icon', {
	    attrs: {
	      "type": "icon-facebook",
	      "dropdown": "true"
	    }
	  })])]) : (this.pledgeVia === 'twitter.com') ? _c('div', [_c('div', {
	    staticClass: "button twitter"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.pledge('twitter.com')
	      }
	    }
	  }, [_vm._v("Pledge to run via Twitter")]), _vm._v(" "), _c('icon', {
	    attrs: {
	      "type": "icon-twitter",
	      "dropdown": "true"
	    }
	  })])]) : (this.pledgeVia === 'google.com') ? _c('div', [_c('div', {
	    staticClass: "button google"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.pledge('google.com')
	      }
	    }
	  }, [_vm._v("Pledge to run via Google")]), _vm._v(" "), _c('icon', {
	    attrs: {
	      "type": "icon-google",
	      "dropdown": "true"
	    }
	  })])]) : (this.pledgeVia === 'password') ? _c('div', [_c('div', {
	    staticClass: "button email"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.pledge('password')
	      }
	    }
	  }, [_vm._v("Pledge to run")]), _vm._v(" "), _c('icon', {
	    attrs: {
	      "type": "icon-mail",
	      "dropdown": "true"
	    }
	  })])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pledgeVia),
	      expression: "pledgeVia"
	    }],
	    attrs: {
	      "name": "pledgeOptions",
	      "id": "pledgeOptions"
	    },
	    on: {
	      "change": function($event) {
	        _vm.pledgeVia = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "facebook.com"
	    }
	  }, [_vm._v("Pledge via Facebook")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "twitter.com"
	    }
	  }, [_vm._v("Pledge via Twitter")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "google.com"
	    }
	  }, [_vm._v("Pledge via Google")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "password"
	    }
	  }, [_vm._v("Pledge via Email address ")])])]), _vm._v(" "), ((this.pledgeVia === 'password' && _vm.showErrors)) ? _c('ul', {
	    staticClass: "errors"
	  }, [_c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.validation.name),
	      expression: "!validation.name"
	    }]
	  }, [_vm._v("Name cannot be empty.")]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.validation.email),
	      expression: "!validation.email"
	    }]
	  }, [_vm._v("Please provide a valid email address.")])]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.isPledgeCompleted),
	      expression: "this.isPledgeCompleted"
	    }]
	  }, [_vm._m(2), _vm._v(" "), _c('p', {
	    staticClass: "bottomMargin"
	  }, [_vm._v("Share your pledge to run in " + _vm._s(this.sharedState.year) + " and encourage people like you get fit and stay healthy.")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "shareButtons"
	    }
	  }, [_c('div', [_c('div', {
	    staticClass: "button facebook"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.share('facebook')
	      }
	    }
	  }, [_c('icon', {
	    attrs: {
	      "type": "icon-facebook",
	      "dropdown": "false"
	    }
	  }), _vm._v("\n                    Share on Facebook\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "button twitter"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.share('twitter')
	      }
	    }
	  }, [_c('icon', {
	    attrs: {
	      "type": "icon-twitter",
	      "dropdown": "false"
	    }
	  }), _vm._v("\n                    Share on Twitter\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "button linkedin"
	  }, [_c('button', {
	    on: {
	      "click": function($event) {
	        _vm.share('linkedin')
	      }
	    }
	  }, [_c('icon', {
	    attrs: {
	      "type": "icon-linkedin",
	      "dropdown": "false"
	    }
	  }), _vm._v("\n                    Share on LinkedIn\n                  ")])])]), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "shareLink"
	  }, [_c('input', {
	    staticClass: "inputField",
	    attrs: {
	      "type": "text",
	      "name": "shareLink",
	      "readonly": "readonly",
	      "placeholder": "URL here",
	      "onClick": "this.setSelectionRange(0, 9999)"
	    },
	    domProps: {
	      "value": this.getSharingUrl()
	    }
	  })])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('section', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!this.isPledgeCompleted),
	      expression: "!this.isPledgeCompleted"
	    }]
	  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("Running is a great free way to get fit and healthy. Take this pledge to show your determination, get reminders about your runs and access useful resources to get you started.\n            "), _c('br'), _c('br'), _c('read-more', {
	    attrs: {
	      "newLine": "true"
	    }
	  }, [_vm._v("\n              To get you started we have curated a list of " + _vm._s(this.sharedState.totalResources) + " resources (and growing) including races, apps, clothing and tips & tricks to avoid injuries. To access this list, make sure you pledge to run in " + _vm._s(this.sharedState.year) + ".\n              "), _c('br'), _c('br'), _vm._v("\n              If you have any suggestion, would like to help us get more people fit or have found a race, accessory, or article you think we should cover, "), _c('a', {
	    attrs: {
	      "href": "mailto:run@runningyear.com",
	      "target": "new"
	    }
	  }, [_vm._v("please get in touch")]), _vm._v(".\n            ")])])]), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "pledge-footer"
	  }, [_c('ul', {
	    attrs: {
	      "id": "footer-email"
	    }
	  }, [_c('li', {
	    staticClass: "email",
	    on: {
	      "click": function($event) {
	        _vm.share('email')
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-mail"
	  }), _vm._v(" Share by Email")])])])])]), _vm._v(" ")])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('h3', [_c('span', [_vm._v("Pledge to run")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "privacy"
	    }
	  }, [_c('label', {
	    staticClass: "icon-lock"
	  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("We will "), _c('b', [_vm._v("not")]), _vm._v(" post anything on your behalf")]), _vm._v(", spam or share your details with third parties.")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('h3', [_c('span', [_vm._v("Encourage others to run")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('h3', [_c('span', [_vm._v("Why pledge to run?")])])
	}]}

/***/ },

/***/ 113:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 114:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.ef078fa80b210b633981.js